{
  "nameInput": {
    "placeholder": "আপনার নাম কী?"
  },
  "signIn": {
    "tagline": "নিয়ত দিয়ে শুরু করুন।",
    "signingIn": "সাইন ইন হচ্ছে…",
    "continueApple": "Apple দিয়ে চালিয়ে যান",
    "continueApple_aria": "Apple দিয়ে চালিয়ে যান",
    "continueGoogle": "Google দিয়ে চালিয়ে যান",
    "continueGoogle_aria": "Google দিয়ে চালিয়ে যান",
    "logo_alt": "Rhemn",
    "footer": "সাইন ইন করার মাধ্যমে, আপনি আমাদের পরিষেবার শর্তাবলী ও <privacyLink>গোপনীয়তা নীতি</privacyLink>-তে সম্মত হন।",
    "divider": "অথবা"
  },
  "email": {
    "identity": {
      "label": "ইমেল ঠিকানা",
      "placeholder": "you@example.com",
      "change": "পরিবর্তন",
      "change_aria": "ইমেল ঠিকানা পরিবর্তন করুন"
    },
    "password": {
      "label": "পাসওয়ার্ড",
      "labelNew": "একটি পাসওয়ার্ড বাছুন",
      "placeholder": "পাসওয়ার্ড",
      "placeholderNew": "একটি পাসওয়ার্ড তৈরি করুন",
      "show": "পাসওয়ার্ড দেখান",
      "hide": "পাসওয়ার্ড লুকান"
    },
    "actions": {
      "continue": "চালিয়ে যান",
      "signIn": "সাইন ইন",
      "createAccount": "অ্যাকাউন্ট তৈরি করুন",
      "forgot": "পাসওয়ার্ড ভুলে গেছেন?",
      "backToSignIn": "সাইন ইনে ফিরে যান",
      "iVerified": "আমি আমার ইমেল যাচাই করেছি",
      "resend": "লিঙ্ক আবার পাঠান",
      "resendIn": "{{time}} পরে আবার পাঠান",
      "signInInstead": "সাইন ইন"
    },
    "busy": {
      "checking": "পরীক্ষা করা হচ্ছে…",
      "signingIn": "সাইন ইন করা হচ্ছে…",
      "creating": "আপনার অ্যাকাউন্ট তৈরি হচ্ছে…",
      "sending": "পাঠানো হচ্ছে…"
    },
    "switch": {
      "toCreate": "Rhemn-এ নতুন? <switchBtn>একটি অ্যাকাউন্ট তৈরি করুন</switchBtn>",
      "toSignIn": "ইতিমধ্যে অ্যাকাউন্ট আছে? <switchBtn>সাইন ইন করুন</switchBtn>"
    },
    "strength": {
      "tooShort": "কমপক্ষে ১২টি অক্ষর।",
      "level1": "ভালো। যত দীর্ঘ, তত শক্তিশালী।",
      "level2": "শক্তিশালী পাসওয়ার্ড।",
      "level3": "খুব শক্তিশালী পাসওয়ার্ড।"
    },
    "sent": {
      "title": "আপনার ইনবক্স দেখুন",
      "body": "আমরা {{email}}-এ একটি রিসেট লিঙ্ক পাঠিয়েছি। এটি এক ঘণ্টা পরে মেয়াদ শেষ হবে।",
      "resent": "আবার পাঠানো হয়েছে। আপনার ইনবক্স দেখুন।"
    },
    "verify": {
      "title": "আপনার ইমেল নিশ্চিত করুন",
      "body": "আমরা {{email}}-এ একটি লিঙ্ক পাঠিয়েছি। আপনার অ্যাকাউন্ট সেট আপ শেষ করতে সেটি খুলুন — এরপর আমরা স্বয়ংক্রিয়ভাবে এগিয়ে নেব।",
      "waiting": "আপনি লিঙ্কটি খোলার অপেক্ষায়…",
      "resent": "আবার পাঠানো হয়েছে। আপনার ইনবক্স দেখুন।"
    },
    "errors": {
      "invalidEmail": "এটি ইমেল ঠিকানার মতো মনে হচ্ছে না।",
      "missingPassword": "আপনার পাসওয়ার্ড লিখুন।",
      "invalidCredential": "ইমেল বা পাসওয়ার্ড সঠিক নয়।",
      "emailInUse": "এই ইমেলে ইতিমধ্যে একটি অ্যাকাউন্ট আছে। <signInBtn>বরং সাইন ইন করুন।</signInBtn>",
      "weakPassword": "কমপক্ষে ১২টি অক্ষর ব্যবহার করুন।",
      "passwordTooShort": "কমপক্ষে ১২টি অক্ষর ব্যবহার করুন।",
      "passwordCommon": "এই পাসওয়ার্ডটি অনুমান করা খুব সহজ। কম অনুমেয় কিছু চেষ্টা করুন।",
      "emailNotVerified": "চালিয়ে যাওয়ার আগে আপনার ইমেল নিশ্চিত করুন।",
      "providerGoogle": "এই ইমেলটি ইতিমধ্যে Google দিয়ে সেট আপ করা আছে। নিচে Google দিয়ে চালিয়ে যান।",
      "providerApple": "এই ইমেলটি ইতিমধ্যে Apple দিয়ে সেট আপ করা আছে। নিচে Apple দিয়ে চালিয়ে যান।",
      "userDisabled": "এই অ্যাকাউন্টটি নিষ্ক্রিয় করা হয়েছে।",
      "requiresRecentLogin": "এই পরিবর্তনটি করতে আবার সাইন ইন করুন।",
      "sessionExpired": "আপনার সেশনের মেয়াদ শেষ হয়েছে। আবার সাইন ইন করুন।",
      "expiredActionCode": "সেই লিঙ্কের মেয়াদ শেষ হয়েছে। নতুন একটি অনুরোধ করুন।",
      "invalidActionCode": "সেই লিঙ্কটি আর বৈধ নয়। নতুন একটি অনুরোধ করুন।",
      "tooManyRequests": "অনেকবার চেষ্টা করা হয়েছে। কয়েক মিনিট অপেক্ষা করুন, বা পাসওয়ার্ড রিসেট করুন।",
      "network": "সংযোগ নেই। আপনার নেটওয়ার্ক দেখে আবার চেষ্টা করুন।",
      "operationNotAllowed": "ইমেল দিয়ে সাইন ইন এখন উপলব্ধ নয়।",
      "generic": "কিছু ভুল হয়েছে। অনুগ্রহ করে আবার চেষ্টা করুন।"
    },
    "a11y": {
      "stepEmail": "২টির মধ্যে ধাপ ১। আপনার ইমেল ঠিকানা লিখুন।",
      "stepPasswordSignIn": "২টির মধ্যে ধাপ ২। সাইন ইন করতে আপনার পাসওয়ার্ড লিখুন।",
      "stepPasswordCreate": "২টির মধ্যে ধাপ ২। আপনার নতুন অ্যাকাউন্টের জন্য একটি পাসওয়ার্ড বাছুন।",
      "stepSent": "রিসেট লিঙ্ক পাঠানো হয়েছে। আপনার ইনবক্স দেখুন।",
      "stepVerify": "অ্যাকাউন্ট তৈরি হয়েছে। যাচাইকরণ লিঙ্ক পাঠানো হয়েছে।",
      "resendReady": "আপনি এখন লিঙ্কটি আবার পাঠাতে পারেন।"
    }
  }
}
